var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cs-product-list" },
    [
      _vm._l(_vm.buttons.Buttons, function (button, index) {
        return _c("app-product-list-item", {
          key: index,
          attrs: { button: button },
          on: {
            add: function ($event) {
              return _vm.addProduct($event)
            },
          },
          nativeOn: {
            contextmenu: function ($event) {
              return _vm.edit($event, index)
            },
          },
        })
      }),
      _c(
        "div",
        {
          staticClass: "add",
          on: {
            click: function ($event) {
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              )
                return null
              return _vm.add()
            },
          },
        },
        [_vm._m(0)]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "item-info" }, [
      _c("div", { staticClass: "product-id" }, [_vm._v("+")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }